import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import { messagingApi } from '../api';

const NewChat: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate();
  const userId = Number(params.userId);

  const [error, setError] = useState('');

  useEffect(() => {
    const go = async () => {
      setError('');
      try {
        if (!userId) {
          setError('Invalid user');
          return;
        }


        const res = await messagingApi.getOrCreateThread(userId);
        navigate(`/messages/thread/${res.thread_id}`);
      } catch (err: any) {
        setError(err.response?.data?.detail || 'Failed to start chat');
      }
    };

    go();
  }, [userId, navigate]);

  return (
    <Layout>
      <div className="pb-20">
        {error ? (
          <div className="bg-red-50 text-red-600 p-3 rounded-lg text-sm">{error}</div>
        ) : (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default NewChat;
